import { render, staticRenderFns } from "./designateOnlineMatrix.vue?vue&type=template&id=3b5ef7f5"
import script from "./designateOnlineMatrix.vue?vue&type=script&lang=js"
export * from "./designateOnlineMatrix.vue?vue&type=script&lang=js"
import style0 from "./designateOnlineMatrix.vue?vue&type=style&index=0&id=3b5ef7f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports